<template>
  <div class="row">
    <div class="small-12 columns">
      <div class="row">
        <div class="course-content-editor-container  small-12 columns">
          <div
            class="close-button absolute cursor-pointer"
            title="Close (Esc)"
            @click="$emit('CLOSE_MODAL')"
          >
            ❌
          </div>
          <div class="small-12 columns">
            <h2>{{ moduleName }}</h2>
          </div>
          <div><h2>Topic Addition</h2></div>
          <div class="small-3 columns">Name</div>
          <div class="small-9 columns">
            <input
              v-model="topicObj.name"
              class="input-box-course-creators"
              type="text"
            />
          </div>
          <div class="small-12 columns">
            <div class="row">
              <div class="small-3 columns">Is required</div>
              <div class="small-9 columns">
                <input
                  v-model="topicObj.is_required"
                  type="checkbox"
                  @click="handleCheckboxChange($event, 'is_required')"
                />
              </div>
            </div>
          </div>
          <div class="small-12 columns">
            <div class="row">
              <div class="small-3 columns">Is bonus</div>
              <div class="small-9 columns">
                <input
                  v-model="topicObj.is_bonus"
                  type="checkbox"
                  @click="handleCheckboxChange($event, 'is_bonus')"
                />
              </div>
            </div>
          </div>
          <div class="small-12 columns py-4">
            <div class="row">
              <div class="small-3 columns">Available on</div>
              <div class="small-9 columns">
                <EdystDatePicker
                  v-model="topicObj.available_on"
                  :selected="
                    topicObj.available_on
                      ? new Date(topicObj.available_on)
                      : null
                  "
                  placeholderText="Select available on date"
                />
              </div>
            </div>
          </div>

          <div class="small-12 columns">
            <div class="small-3 columns">Is Dependent IDs</div>
            <div class="small-9 columns">
              <multiselect
                v-model="selected"
                :options="topics"
                label="name"
                :multiple="true"
                @remove="removeTag"
              />
            </div>
          </div>
          <div class="small-12 columns">
            <button
              class="border border-green bg-green text-white py-2 px-4 rounded-sm"
              @click="addTopic"
            >
              Add Topic
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"
import { mapGetters, mapActions } from "vuex"
import siteConfig from "@/utils/siteConfig"
import EdystDatePicker from "@/components/ReactDatePicker/DatePicker"

export default {
  components: { Multiselect, EdystDatePicker },
  props: ["topics", "is_required", "is_bonus"],
  computed: {
    ...mapGetters("module", ["getCurrentModuleID"]),
  },
  data() {
    return {
      selected: [],
      topicObj: {
        name: "",
        is_required: true,
        is_bonus: false,
        available_on: null,
      },
      moduleName: "",
    }
  },
  created() {
    // restore previously selected state
    this.topicObj.is_required = this.is_required
    this.topicObj.is_bonus = this.is_bonus
  },
  methods: {
    ...mapActions("module", [
      "UPDATE_MODULE",
      "LOAD_CURRENT_COURSES_EDITING_STATE",
    ]),
    handleCheckboxChange(e, name) {
      const payload = {}
      payload[name] = e.target.checked // the key is dynamic
      this.$emit("CHECKBOX_STATE_CHANGE", payload)
    },
    removeTag(tag) {
      let index
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i].id === tag.id) {
          index = i
        }
      }
      this.selected = this.selected.splice(index, 1)
    },
    getModuleDetailsById() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}modules/${this.getCurrentModuleID}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        let name = ""
        name = res.data.data.name
        this.moduleName = name
      })
    },
    addTopic() {
      const topicCreator = this.$loading.show()
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/topics`,
        data: this.topicObj,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          topicCreator.hide()
          if (this.topicObj.available_on) {
            const isoDate = new Date(this.topicObj.available_on).toISOString()
            res.data.available_on = isoDate
          }
          this.topicObj.is_dependent_ids = this.selected.map(item => item.id)
          this.$emit("TOPIC_CREATED", res.data, this.topicObj.is_dependent_ids)
        })
        .catch(() => {
          topicCreator.hide()
        })
    },
  },
  mounted() {
    this.getModuleDetailsById()
  },
}
</script>

<style scoped>
.course-content-editor-container > div > div {
  margin: 0.3rem 0;
}
</style>
